const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: "lista",
	lista: [],
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case "EMPRESA_MODO_TELA":
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro,
			};

		case "EMPRESA_SET_AGUARDANDO":
			return { ...state, aguardando: action.payload };

		case "EMPRESA_FILTRO":
			return { ...state, filtro: action.payload };

		case "EMPRESA_LISTADO":
			return {
				...state,
				lista: action.payload.data,
			};
		case "EMPRESA_SELECT_LISTADO":
			return {
				...state,
				listaSelect: action.payload.data,
			};

		default:
			return state;
	}
};
